<script setup lang="ts">
import { Customer } from '../../../../types/models';


const props = defineProps<{
  customer: Customer;
  selected: boolean;
}>();

const emit = defineEmits<{
  (e: 'select', customer: Customer): void;
}>();

function selectCustomer() {
  emit('select', props.customer);
}
</script>

<template>
  <div 
    class="card mb-3 transition-all duration-200"
    :class="{ 'border-2 border-primary-500 bg-primary-50': selected }"
    @click="selectCustomer"
  >
    <div class="flex items-center justify-between">
      <div class="flex-1">
        <h3 class="font-semibold text-neutral-900">{{ customer.name }}</h3>
        <p class="text-sm text-neutral-600">{{ customer.mobile }}</p>
        <p class="text-sm text-neutral-600">{{ customer.address }}</p>
        <p v-if="customer.tax_registration_no" class="text-sm text-neutral-500 mt-1">TIN No:{{ customer.tax_registration_no }}</p>
      </div>
      
      <div v-if="selected" class="text-primary-500">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
      </div>
    </div>
  </div>
</template>